module.exports = __webpack_public_path__ + "static/img/Fshow.eda3a07d.png";